var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('bill.analysis_cost_alarm')}}),_c('page-body',[_c('analysis-alarm-list',{attrs:{"id":"AnalysisAlarmList"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }